// extracted by mini-css-extract-plugin
export default {"signupHeaderOne":"signup-layout_signupHeaderOne__dMqu0","signupHeaderTwo":"signup-layout_signupHeaderTwo__MrR49","contentContainer":"signup-layout_contentContainer__BgqYJ"};